import React from "react";

import { LinearProgress, Typography } from "@mui/material";
import styled from "@mui/material/styles/styled";

import { isEnglishLang } from "@app/analytics/utils/langUtils";

import Stack from "@rui/Stack";

const OuterContainer = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  justifyContent: "center",
  flex: 1,
  background: theme.palette.background.emblem,
  padding: theme.spacing(1),
}));

const InnerContainer = styled(Stack)(({ theme }) => ({
  height: "200px",
  width: "400px",
  maxHeight: "100%",
  maxWidth: "100%",
  backgroundColor: "#FFF",
  borderRadius: "8px",
  boxShadow: theme.shadows[4],
  padding: theme.spacing(4),
}));

export const Container = ({ children }: { children: React.ReactNode }) => (
  // Protects against translate issues when detected language is english and the
  // user is using an extension to translate the page to another language.
  <OuterContainer translate={isEnglishLang() ? "no" : undefined}>
    <InnerContainer spacing={2} variant="center">
      {children}
    </InnerContainer>
  </OuterContainer>
);

export const DownloadProgress = styled(LinearProgress)({
  height: "12px",
  width: "300px",
  maxWidth: "100%",
  borderRadius: "8px",
});

export const ProgressText = styled(Typography)({
  textAlign: "center",
});
